export default {
  zh: {
    question: '邀请好友赠送的服务时长如何计算？',
    answer: '奖励天数 = 邀请奖励天数基础值 / 套餐台数。比如说，您是 1 台设备套餐，邀请好友购买了 1 台设备的月套餐，则您和好友都可获得 5 天的奖励天数（5/1=5）。如果您是 2 台设备套餐，邀请好友购买了 1 台设备年付套餐，则您可以获得 15 天的奖励天数（30/2=15），好友可以获得 30 天的奖励天数（30/1=30）。邀请奖励天数基础值阶梯表如下：',
    img: 'reward_rules_cn'
  },
  en: {
    question: 'How to calculate the reward time for inviting friends to use PlexVPN?',
    answer: 'Reward time = Tier reward time standard / Device number. For example, if you have bought 1 device plan, and successfully referred your friend to buy 1 device monthly plan, both of you will get a 5-day reward time (5/1=5); If your device number is 2, and you have successfully referred your friend to buy 1 device yearly plan, you’ll get 15-day reward time(30/2=15) and your friend will get 30-day reward time( 30/1=30). The ladder table of tier reward time standards is as follows:',
    img: 'reward_rules_en'
  }
}


// WEBPACK FOOTER //
// ./src/views/rewardRules/lang.js